import Attach from '@tools/attach';
import eventBus from '@tools/event-bus';
import { showSubmitLoader } from '@atoms/spinner';

/**
 * User profile manage page
 */
export default function () {
  if (document.querySelectorAll('.user-manage-page').length) {
    Attach.onClickEvent('delete-account-cta', () => {
      eventBus.dispatchEvent(new Event('show-delete-modal'));
    });
  }

  const notifications = document.querySelector('.notifications');

  if (notifications) {
    notifications.querySelector('form').addEventListener('submit', () => {
      showSubmitLoader(notifications.querySelector('button'));
    });
  }
}
